export const GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_REQUESTED =
  "GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_REQUESTED";
export const GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_SUCCEEDED =
  "GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_SUCCEEDED";
export const GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_FAILED =
  "GET_INVALIDATE_INTERVIEW_EMAIL_TEMPLATE_FAILED";
export const SESSION_EDIT_SINGLE_OPEN = "SESSION_EDIT_SINGLE_OPEN";
export const SESSION_EDIT_MULTIPLE_OPEN = "SESSION_EDIT_MULTIPLE_OPEN";
export const SESSION_EDIT_STEP = "SESSION_EDIT_STEP";
export const SESSION_EDIT_CHOOSE_ACTION = "SESSION_EDIT_CHOOSE_ACTION";
export const SESSION_EDIT_NEXT = "SESSION_EDIT_NEXT";
export const SESSION_EDIT_BACK = "SESSION_EDIT_BACK";
export const SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE =
  "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE";
export const SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED =
  "SEND_SINGLE_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED";
export const SEND_MULTI_SESSION_RESCHEDULE_MESSAGE =
  "SEND_MULTI_SESSION_RESCHEDULE_MESSAGE";
export const SEND_MULTI_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED =
  "SEND_MULTI_SESSION_RESCHEDULE_MESSAGE_SUCCEEDED";
export const SESSION_EDIT_MULTIPLE_TOGGLE = "SESSION_EDIT_MULTIPLE_TOGGLE";
export const SESSION_EDIT_SINGLE_TOGGLE = "SESSION_EDIT_SINGLE_TOGGLE";
export const UPDATE_MESSAGE_PANE_STATE = "UPDATE_MESSAGE_PANE_STATE";
export const SESSION_EDIT_TOGGLE_COMPLETION_WARNING =
  "SESSION_EDIT_TOGGLE_COMPLETION_WARNING";
export const SESSION_EDIT_ADDITIONAL_CHARGE_TOGGLE =
  "SESSION_EDIT_ADDITIONAL_CHARGE_TOGGLE";
export const SESSION_EDIT_TOGGLE_TIMESLOT = "SESSION_EDIT_TOGGLE_TIMESLOT";
export const SESSION_EDIT_TOGGLE_SELECT_ALL = "SESSION_EDIT_TOGGLE_SELECT_ALL";
export const TOGGLE_TIMESLOT_MODAL = "TOGGLE_TIMESLOT_MODAL";
export const GET_EMAIL_TEMPLATE_REQUESTED = "GET_EMAIL_TEMPLATE_REQUESTED";
export const GET_EMAIL_TEMPLATE_SUCCEEDED = "GET_EMAIL_TEMPLATE_SUCCEEDED";
export const GET_EMAIL_TEMPLATE_FAILED = "GET_EMAIL_TEMPLATE_FAILED";
export const CLOSE_TEMPLATE = "CLOSE_TEMPLATE";
